export default {
  initializePendo(email, name, role, visitorId, payerCompany, accountId, merchantId, merchantName, accountName) {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const searchParams = new URLSearchParams(url.search);
    const transactionId = searchParams.get("transactionId");
    // Add user details to initialise Pendo

    if ("pendo" in window) {
      window.pendo.initialize({
        visitor: {
          id: email ?? "", // Required if user is logged in, default creates anonymous ID
          Visitor_Id: String(visitorId ?? ""),
          email: email ?? "", // Recommended if using Pendo Feedback, or NPS Email
          User_Name: email ?? "",
          full_name: name ?? "", // Recommended if using Pendo Feedback
          role: role ?? "", // Optional : You can add any additional visitor level key-values here,
          Payer_Company: payerCompany ?? ""
        },
        account: {
          id: String(accountId ?? ""),
          Account: String(accountId ?? ""),
          Merchant_ID: String(merchantId ?? ""),
          Merchant_Name: merchantName ?? "",
          Account_Name: accountName ?? "",
          Transaction_Id: transactionId
        },
      });
    }
  },
};
